import { Grid, Typography } from "@mui/material";
import AppMaintenance from "../../assets/png/maintenance.jpeg";
import { useTranslation } from "react-i18next";
import { redirectionAfterMaintenance } from "../../utils/common";

export const AppMaintenanceTile = ({ appSettings }) => {
  const { t } = useTranslation();
  const isMaintenancePage = window.location.pathname === "/maintenance";

  redirectionAfterMaintenance(appSettings);

  return (
    !isMaintenancePage && (
      <Grid
        display={"flex"}
        minHeight={{ xs: "10vh", md: "5vh" }}
        width={"100vw"}
        padding={2}
        backgroundColor="#fff4cc"
        justifyContent={"center"}
      >
        {/* currenty removed image form banner  */}
        {/* <Grid>
        <img src={AppMaintenance} height={40} width={40} />
      </Grid> */}
        <Grid display={"flex"} alignItems={"center"}>
          <Typography
            style={{
              fontFamily: "Segoe UI",
              fontSize: 14,
              fontWeight: 600,
              textAlign: "center",
              marginLeft: "20px",
              marginRight: "20px",
            }}
          >
            {appSettings?.message || t("components.modalText.text1")}
          </Typography>
        </Grid>
      </Grid>
    )
  );
};
